<template>
    <VDialog v-model="aberto" persistent width="300">
        <VCard color="primary" dark>
            <VCardText>
                {{ texto }}
                <VProgressLinear indeterminate color="white" class="mb-0"/>
            </VCardText>
        </VCard>
    </VDialog>
</template>

<script>
    export default {
        data() {
            return {
                aberto: false,
                texto: null
            };
        },
        methods: {
            abrir(texto = null) {
                this.texto = texto || 'Carregando';
                this.aberto = true;
            },
            fechar() {
                this.aberto = false;
            },
            async aguardarPromises(promises, texto) {
                this.abrir(texto);
                try {
                    return await Promise.all(promises);
                } catch (e) {
                    throw e;
                } finally {
                    this.fechar();
                }
            },
            async aguardarPromisesSemTexto(promises) {
              try {
                return await Promise.all(promises);
              } catch (e) {
                throw e;
              }
            },
        }
    };
</script>
